<template>

    <div class="antialiased bg-gray-200 text-gray-900 font-sans">
        <div class="flex items-center h-screen w-full">
            <div class="w-full bg-white rounded shadow-lg p-8 m-4 md:max-w-sm md:mx-auto">
                <div class="flex flex-wrap w-full justify-center mb-6">
                    <img alt="school logo" class=" flex h-20 w-20 mb-1" src="../images/gciosa.png">
                    <p class="container font-serif text-xl capitalize font-bold text-center">Login</p>
                </div>


                <div class="mb-4">
<!--                    <div class="py-4" v-if="errors.length">-->

<!--                        <b>Please correct the following error(s): </b>-->

<!--                        <ul>-->
<!--                            <li v-for="error in errors">{{ error }}</li>-->
<!--                        </ul>-->

<!--                    </div>-->

                    <div class="mb-6 md:w-full">
                        <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="phone_number">Phone Number</label>
                        <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400"
                               id="phone_number" name="phone_number" placeholder="Phone number"
                               v-model="phone_number">
                    </div>
                    <div class="mb-2 md:w-full">
                        <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="password">Password</label>
                        <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400"
                               id="password" name="password" placeholder="Password" type="password"
                               v-model="password">
                    </div>

                    <p class="flex">
                        <a class="w-full text-blue-700 text-right text-sm font-semibold" href="#">Forgot password?</a>
                    </p>

                </div>

                <div class="flex">
                    <input type="checkbox" id="user_type" name="user_type" v-model="admin">

                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold ml-2" for="user_type"> I'm an admin</label>
                </div>


                <div class="flex-wrap mt-6 justify-center">
                    <div class="flex mx-auto mb-3" v-if="loading">
                        <!-- <img alt="school logo" class="object-contain h-10 w-20" src="../images/loading.gif"> -->
                        <vue-loaders
                         name="ball-spin-fade-loader" color="#2a4365" class="mx-auto my-4" scale="1"></vue-loaders>
                    </div>
                    <button @click="login"
                            class="flex mx-auto bg-blue-700 hover:bg-blue-900 text-white uppercase tracking-wider text-sm
                    font-semibold px-10 py-3 mb-3 rounded">
                        Login
                    </button>


                    <p class="flex mx-auto items-center justify-center mb-6">
                        <a class="text-blue-700 text-center text-sm font-semibold cursor-pointer" @click="goToRegister">Create an account</a>
                    </p>


                </div>


            </div>

        </div>
    </div>
</template>

<style scoped>

    input[type=checkbox] {
        transform: scale(1.3);
    }

</style>

<script>

    import Axios from 'axios'
    // import router from '../js/routes';
    


    export default {


        data: function () {
            return {
                loading: false,
                errors: [],
                phone_number: null,
                password: null,
                admin: false,
            }
        },

        methods: {
            login: function (e) {

                if (this.phone_number && this.password) {
                    this.loading = true;
                    Axios.post('api/login',
                        {phone_number: this.phone_number, password: this.password, user_type: `${this.admin ? 'admin' : 'user'}`},
                        {headers: {'Content-Type': 'application/json'}}
                    ).then(response => {
                        this.loading = false;
                        // console.log(response.data);
                        if (response.data.status) {
                            // console.log(response.data);
                            const authToken = (response.data.token.original.access_token);
                            localStorage.setItem('token', authToken);

                            // console.log(authToken);
                            this.$swal({
                                toast: true,
                                position: 'top-end',
                                icon: 'success',
                                title: `Welcome, ${response.data.user.first_name}`,
                                showConfirmButton: false,
                                timer: 1500
                            });

                            this.$router.push( this.admin ? '/dashboard' : '/home');



                        } else {
                            // console.log(response.data);
                            this.$swal({
                                toast: true,
                                position: 'top-end',
                                title: response.data.message || response.data.error,
                                showConfirmButton: false,
                                timer: 3000
                            });
                            // this.$swal();
                            this.errors.push(response.data.message)
                        }
                    });
                    // .catch(function(error) {
                    //     if (error.response && error.response.status === 401) {
                    //         console.log(error.response.data.status);
                    //     } else {
                    //         // Handle error however you want
                    //     }
                    // });
                }else{

                this.errors = [];

                if (!this.phone_number) {
                    this.errors.push('Phone number required');
                }

                if (!this.password) {
                    this.errors.push('Password required');
                }

                this.$swal({
                    toast: true,
                    position: 'top-end',
                    title: this.errors,
                    showConfirmButton: false,
                    timer: 3000
                });

                e.preventDefault();
                }
            },

            pushError: function (error) {
                this.errors.push(error);
            },
            goToRegister(){
                this.$router.push('/register');
            },
        }
    }
</script>
